import { actionCreator } from '../../utils/actions';

export const changeCurrentDevice = actionCreator('CHANGE_CURRENT_DEVICE');



// WEBPACK FOOTER //
// ./src/components/Header/actions.js